export default "__VITE_ASSET__3e4ff6d6__"